const getCheckDigit = (vin: string) => {
    const map = '0123456789X';
    const weights = '8765432X098765432';
    const sum = vin.split('').reduce((sum, char, index) => {
        return sum + transliterate(char) * map.indexOf(weights[index]);
    }, 0);
    return map[sum % 11];
};

const transliterate = (char: string) => '0123456789.ABCDEFGH..JKLMN.P.R..STUVWXYZ'.indexOf(char) % 10;

export const isVinValid = (vin: string) => {
    if (!vin) return true;
    if (vin.length !== 17) return false;
    return getCheckDigit(vin) === vin[8];
};
